import { styled, theme } from '@clickcease/cc-client-components-lib'

const {
  space: {
    1: { value: space1 },
  },
} = theme

export const ProductStyle = styled('div', {
  flexBasis: '50%',
  borderRadius: '$medium',
  border: '1px solid $veryLightNeutral',
  padding: '$11',
  boxShadow: '$card',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
  fontFamily: 'Open Sans',
  justifyContent: 'space-between',
  variants: {
    variant: {
      disabled: {
        color: '$gray',
        gap: '$10',
        justifyContent: 'start',
        paddingTop: '$8',
      },
    },
  },
})

export const Title = styled('div', {
  color: '$black',
  fontWeight: '$sb',
  fontSize: '$lg',
  textAlign: 'center',
  variants: {
    variant: {
      disabled: {
        color: '$gray',
      },
    },
  },
})

export const ProductText = styled('div', {
  fontWeight: '$sb',
  fontSize: '$lg',
  color: '$primaryColor',
  margin: '$10 0',
})

export const Divider = styled('div', {
  width: space1,
  margin: '0 $4',
  background: '$lightDisabled',
})

export const TextContainer = styled('div', {
  display: 'flex',
  fontWeight: '$l',
  fontSize: '$md',
})

export const BoldText = styled('span', {
  fontWeight: '$sb',
})

export const Label = styled('span', {
  padding: '$2 $4',
  display: 'flex',
  alignItems: 'center',
  borderRadius: '$normal',

  '@laptop': {
    padding: '$1 $2',
  },

  variants: {
    variant: {
      lowRisk: {
        color: '$black',
        background: '$lightRed',
      },
      success: {
        color: '$green',
        background: '$lightGreen',
      },
      warning: {
        color: '$gold',
        background: '$lightGold',
      },
      default: {
        background: '$lightGray',
        color: '$black',
      },
      critical: {
        background: '$lightRed',
        color: '$black',
      },
      high: {
        background: '$lightOrange',
        color: '$black',
      },
    },
  },
})

export const LabelsContainer = styled('div', {
  display: 'flex',
  gap: '$5',
  fontWeight: '$r',
  fontSize: '$sm',
  alignItems: 'center',
  justifyContent: 'center',
})
